import { usePermissions } from "contexts/permission";
import { useQuery } from "@tanstack/react-query";

// Rule-based permission hook
export function usePermissionRules(rules, collection, field) {
  const permissions = usePermissions();

  return useQuery({
    queryKey: [
      "permission-rules",
      rules,
      collection,
      permissions.context,
      field,
    ],
    queryFn: async () => {
      try {
        const value = await permissions.canByRules(rules, collection, {
          projectSlug: permissions.context.projectSlug,
          jobId: permissions.context?.jobId,
          billableId: permissions.context?.billableId,
          milestoneId: permissions.context?.milestoneId,
          casestudyId: permissions.context?.casestudyId,
          field,
        });

        return value;
      } catch (e) {
        console.error("Error in canByRules", e);
        throw e; // rethrow for react-query to catch
      }
    },
    enabled: !!permissions.user?.id,
  });
}
